import * as React from "react";
import { Grid, Snackbar } from "@mui/material";
import { Alert } from '@mui/material';

interface Props {
  customMessage?: any;
}

const NoAccessContent: React.FC<Props> = (props: any) => {
  return (
    <div className="">
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      style={{ marginLeft: "120px" }}
    >
      <h3>Sorry, you do not have access to this page.</h3>
    </Grid>
  </div>
  );
};

export default NoAccessContent;
